import { render } from "./addcustomeropti.vue?vue&type=template&id=36d4d7e8"
import script from "./addcustomeropti.vue?vue&type=script&lang=js"
export * from "./addcustomeropti.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__